import { cloudFunction } from 'services/parse';

export const fetchUsers = (data: Record<string, any>) => {
  return cloudFunction('fetchUsers', data);
};

export const getUserDetail = (id: string) => {
  return cloudFunction('getUserDetail', { id });
};

export const fetchSuppliersForUser = async (data: Record<string, any>) => {
  const response = await cloudFunction('fetchSuppliersForUser', data);
  return {
    items: response.items.map(item => ({ ...item.supplier })),
    total: response.total,
  };
};

export const createUser = (params: {email: string; password: string; phone: string; firstName: string; lastName: string}) => {
  const { email, lastName, firstName, password, phone } = params;
  return cloudFunction('createUser', { email, password, phone, lastName, firstName });
};

export const fetchUserInventoryItemPreferences = (data: Record<string, any>) => {
  return cloudFunction('fetchUserInventoryItemPreferences', data);
};

export const fetchUserInventoryItemPreferencesForAdmin = (data: Record<string, any>) => {
  return cloudFunction('fetchUserInventoryItemPreferencesForAdmin', data);
};

export const createUserInventoryItemPreference = (data: Record<string, any>) => {
  return cloudFunction('createUserInventoryItemPreferenceForAdmin', data);
};

export const updateUserInventoryItemPreference = (data: Record<string, any>) => {
  return cloudFunction('updateUserInventoryItemPreferenceForAdmin', data);
};

export const deleteUserInventoryItemPreference = (data: Record<string, any>) => {
  return cloudFunction('deleteUserInventoryItemPreferenceForAdmin', data);
};

export const assignRoleToUser = (data: Record<string, any>) => {
  return cloudFunction('assignRole', data);
};

export const removeRoleFromUser = (data: Record<string, any>) => {
  return cloudFunction('removeUserFromRole', data);
};

export const fetchRoleForUser = (data: Record<string, any>) => {
  return cloudFunction('fetchRoles', data);
};

export const updateUser = (data: Record<string, any>) => {
  return cloudFunction('updateUser', data);
};

export const fetchUsersInRole = (data: Record<string, any>) => {
  return cloudFunction('fetchUsersInRole', data);
};
